import { render, staticRenderFns } from "./Public.vue?vue&type=template&id=f047c530"
import script from "./Public.vue?vue&type=script&lang=js"
export * from "./Public.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f047c530')) {
      api.createRecord('f047c530', component.options)
    } else {
      api.reload('f047c530', component.options)
    }
    module.hot.accept("./Public.vue?vue&type=template&id=f047c530", function () {
      api.rerender('f047c530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Public.vue"
export default component.exports